import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import TituloComponent from '../../components/Titulo/TituloComponent';

// api
import { efetuarLogin } from '../../services/api';

// css
import 'bootstrap/dist/css/bootstrap.min.css';
import './AreaRestritaPage.css';
import '../../styles/global.css';


const AreaRestrita = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    userData: JSON.parse(sessionStorage.getItem('userData')) || {}, // Tenta pegar o userData da sessão
  });
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // Verificar o status do usuário ao carregar a página
  useEffect(() => {
    console.log('Verificando status do usuário na sessão...');

    const userData = sessionStorage.getItem('userData');
    if (userData) {
      console.log('usuário ESTÁ logado!');
      try {
        const parsedData = JSON.parse(userData);
        console.log('Dados do usuário na sessão:', parsedData);

        // Verifica se o statusUsuario é 'logado'
        if (parsedData.statusUsuario === 'logado') {
          console.log('Usuário está logado. Redirecionando...');
          navigate('/usuario-logado', { state: { userData: parsedData } }); // Passando todos os dados de parsedData
        } else {
          console.log('Usuário não está logado, mantendo na área restrita.');
        }
      } catch (error) {
        console.error('Erro ao parsear os dados de usuário:', error);
      }
    } else {
      console.log('Usuário NÃO está logado!');
    }
  }, [navigate]); // Re-executa o efeito toda vez que o componente é renderizado

  // Função para atualizar os campos do formulário
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  // Função para enviar os dados do formulário
  const handleSubmit = async (e) => {
    console.log('Entrou no handleSubmit do login...');
    e.preventDefault();
    try {
      const response = await efetuarLogin(formData);
      const message = response.message;

      console.log('--------------------------------');
      console.log('User', response.user);
      console.log('token', response.token);
      console.log('status do usuário', response.statusUsuario);
      console.log('--------------------------------');

      // Atualizar o state com os dados do response
      setFormData((prevData) => ({ ...prevData, userData: response }));

      // Armazenar todos os dados de response na sessão
      sessionStorage.setItem('userData', JSON.stringify(response)); // Armazenando todos os dados
      // sessionStorage.setItem('userToken', JSON.stringify(response.token)); // Se necessário, armazena o token também

      // alert(message);

      // Redireciona para a página do usuário logado com todos os dados
      navigate('/usuario-logado', { state: { userData: response } });

      setError('');
    } catch (error) {
      console.error('Erro ao logar:', error);
      const errorMessage = error.response?.data?.message || 'Erro ao logar. Tente novamente.';
      setError(errorMessage); // Define a mensagem de erro no estado
    }
  };

  // Função para redirecionar ao formulário de cadastro do gerente
  const handleGerenteRegisterClick = () => {
    navigate('/form-cadastrar-gerente'); // Redireciona para a página de cadastro
  };

  // Função para redirecionar ao formulário de cadastro do cliente
  const handleClienteRegisterClick = () => {
    navigate('/form-cadastrar-cliente'); // Redireciona para a página de cadastro
  };

  return (
    <div className="area-restrita-container">
      <TituloComponent />

      <div className="login-form-container">
        <h2 className="login-title">Login</h2>

        {error && <div className="alert alert-danger">{error}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              className="form-control"
              placeholder="Digite seu email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="senha">Senha</label>
            <input
              type="password"
              id="password"
              name="password"
              className="form-control"
              placeholder="Digite sua senha"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>

          <button type="submit" className="btn btn-primary btn-block">
            Entrar
          </button>
        </form>
      </div>


        {/* Container de quadros */}
        <div className="quadros-container">

            <div className="register-link-container" onClick={handleGerenteRegisterClick}>
              <p className="register-link-text">
                Quero me cadastrar para tornar meu bar, inteligente
              </p>
            </div>

            <div className="register-link-container" onClick={handleClienteRegisterClick}>
              <p className="register-link-text">
                Quero me cadastrar como Cliente
              </p>
            </div>
           
        </div>




    </div>
  );
};

export default AreaRestrita;
